import { render, staticRenderFns } from "./block2.vue?vue&type=template&id=0ac5524a&scoped=true&"
import script from "./block2.vue?vue&type=script&lang=js&"
export * from "./block2.vue?vue&type=script&lang=js&"
import style0 from "./block2.vue?vue&type=style&index=0&id=0ac5524a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac5524a",
  null
  
)

export default component.exports